import {Col, Row} from "antd";
import "./style.scss";
import {error_500} from "../../../../AppImageConst";


export const Error500Page = () => {
    return (
        <div className="error_500_container">
            <Row>
                <Col span={24} className={'center-contents'}>
                    <img className='error_500_img' src={error_500} alt="error_500"/>
                </Col>
                <Col span={24} className={'center-contents'}>
                    <h2>500</h2>
                </Col>
                <Col span={24} className={'center-contents'}>
                    <h4>
                        Sorry, something went wrong. Please contact your administrator!
                    </h4>
                </Col>
            </Row>
        </div>
    );
};
